import { isSparkJsVersionAtLeast } from '../lib/sparkjs-version';

export const SPARKJS_FEATURE_VERSIONS = Object.freeze({
  CHECKOUT_STANDARD_ELEMENTS: '4.7.0',
});

export type SparkJsFeature = keyof typeof SPARKJS_FEATURE_VERSIONS;

export function isSparkJsFeatureUnlocked(
  version: string | null | undefined,
  feature: SparkJsFeature,
): boolean {
  return isSparkJsVersionAtLeast(version, SPARKJS_FEATURE_VERSIONS[feature]);
}
